export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-user',
        admin: true,
      },
    },
    {
      name: 'clients',
      displayName: 'menu.clients',
      meta: {
        iconClass: 'va-icon fa fa-group',
        admin: true,
      },
    },
    {
      name: 'partners',
      displayName: 'menu.partners',
      meta: {
        iconClass: 'va-icon fa fa-handshake-o',
        admin: true,
        partner: true,
      },
    },
    {
      name: 'partner-report',
      displayName: 'menu.partnerReport',
      meta: {
        iconClass: 'va-icon fa fa-handshake-o',
        admin: -1,
        partner: true,
      },
    },
    {
      name: 'plans',
      displayName: 'menu.plans',
      meta: {
        iconClass: 'vuestic-iconset vuestic-iconset-files',
        admin: true,
      },
    },
    {
      name: 'trial',
      displayName: 'menu.trial',
      meta: {
        iconClass: 'va-icon fa fa-gift',
        admin: true,
        partner: true,
      },
    },
    {
      name: 'plan-items',
      displayName: 'menu.plan-items',
      meta: {
        iconClass: 'va-icon fa fa-star-o',
        admin: true,
      },
    },
    {
      name: 'app-features',
      displayName: 'menu.app-features',
      meta: {
        iconClass: 'va-icon fa fa-toggle-on',
        admin: true,
      },
    },
    {
      name: 'chat-block',
      displayName: 'menu.chatBlock',
      meta: {
        iconClass: 'fa fa-comment',
      },
    },
    /* {
      name: 'rooms',
      displayName: 'menu.rooms',
      meta: {
        iconClass: 'va-icon fa fa-send-o',
        admin: true,
      },
    }, */
    {
      name: 'futebol',
      displayName: 'menu.futebol',
      disabled: true,
      meta: {
        iconClass: 'va-icon fa fa-futbol-o',
        partner: false,
        external: false,
      },
      children: [
        {
          name: 'clubs',
          displayName: 'menu.clubs',
        },
        {
          name: 'championships',
          displayName: 'menu.championships',
        },
      ],
    },
    {
      name: 'week-groups',
      displayName: 'menu.weeksGroup',
      meta: {
        iconClass: 'va-icon fa fa-calendar',
      },
    },
    {
      name: 'sena-editions',
      displayName: 'menu.sena',
      meta: {
        iconClass: 'va-icon fa fa-bullseye',
      },
    },
    /* {
      name: 'live',
      displayName: 'menu.live',
      disabled: true,
      meta: {
        iconClass: 'va-icon fa fa-signal',
      },
      children: [
        {
          name: 'liveComponents',
          displayName: 'menu.liveComponents',
        },
      ],
    }, */
    {
      name: 'reports',
      displayName: 'menu.reports.title',
      disabled: true,
      meta: {
        iconClass: 'va-icon fa fa-file',
        admin: true,
      },
      children: [
        {
          name: 'report-partners',
          displayName: 'menu.reports.partners',
        },
      ],
    },
    {
      name: 'rewards',
      displayName: 'menu.rewards.title',
      disabled: true,
      meta: {
        iconClass: 'va-icon fa fa-exchange',
        admin: true,
      },
      children: [
        {
          name: 'products',
          displayName: 'menu.rewards.products',
        },
        {
          name: 'rescues',
          displayName: 'menu.rewards.rescues',
        },
      ],
    },
    {
      name: 'invoices',
      displayName: 'menu.invoices',
      meta: {
        iconClass: 'va-icon fa fa-credit-card',
        admin: true,
      },
    },
    {
      name: 'transmissions',
      displayName: 'menu.transmissions',
      meta: {
        iconClass: 'va-icon fa fa-youtube-play',
      },
    },
    {
      name: 'notificacoes-link',
      displayName: 'menu.notificacoesLink',
      meta: {
        iconClass: 'va-icon fa fa-send-o',
      },
    },
    {
      name: 'club-videos',
      displayName: 'menu.club-videos',
      meta: {
        iconClass: 'va-icon fa fa-video-camera',
        partner: false,
        external: false,
      },
    },
    {
      name: 'videos',
      displayName: 'menu.videos',
      meta: {
        iconClass: 'va-icon fa fa-video-camera',
      },
    },
    {
      name: 'columnists',
      displayName: 'menu.columnist',
      meta: {
        iconClass: 'va-icon fa fa-newspaper-o',
        external: true,
      },
    },
    {
      name: 'posts',
      displayName: 'menu.posts',
      meta: {
        iconClass: 'va-icon fa fa-newspaper-o',
        external: true,
      },
    },
    {
      name: 'raffles',
      displayName: 'menu.raffles',
      meta: {
        iconClass: 'va-icon fa fa-bitbucket',
      },
    },
    /* {
      name: 'rss',
      displayName: 'menu.rss',
      meta: {
        iconClass: 'va-icon fa fa-rss',
        admin: true,
      },
    }, */
    {
      name: 'promotions',
      displayName: 'menu.promotions',
      meta: {
        iconClass: 'va-icon fa fa-share',
        admin: true,
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        iconClass: 'va-icon fa fa-cog',
        admin: true,
      },
    },
    // {
    //   name: 'statistics',
    //   displayName: 'menu.statistics',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-statistics',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'charts',
    //       displayName: 'menu.charts',
    //     },
    //     {
    //       name: 'progress-bars',
    //       displayName: 'menu.progressBars',
    //     },
    //   ],
    // },
    // {
    //   name: 'forms',
    //   displayName: 'menu.forms',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-forms',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'form-elements',
    //       displayName: 'menu.formElements',
    //     },
    //     {
    //       name: 'medium-editor',
    //       displayName: 'menu.mediumEditor',
    //     },
    //   ],
    // },
    // {
    //   name: 'tables',
    //   displayName: 'menu.tables',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-tables',
    //   },
    //   children: [
    //     {
    //       name: 'markup',
    //       displayName: 'menu.markupTables',
    //     },
    //     {
    //       name: 'data',
    //       displayName: 'menu.dataTables',
    //     },
    //   ],
    // },
    // {
    //   name: 'ui',
    //   displayName: 'menu.uiElements',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-ui-elements',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'buttons',
    //       displayName: 'menu.buttons',
    //     },
    //     {
    //       name: 'cards',
    //       displayName: 'menu.cards',
    //     },
    //     {
    //       name: 'chat',
    //       displayName: 'menu.chat',
    //     },
    //     {
    //       name: 'chips',
    //       displayName: 'menu.chips',
    //     },
    //     {
    //       name: 'collapses',
    //       displayName: 'menu.collapses',
    //     },
    //     {
    //       name: 'colors',
    //       displayName: 'menu.colors',
    //     },
    //     {
    //       name: 'color-pickers',
    //       displayName: 'menu.colorPickers',
    //     },
    //     {
    //       name: 'file-upload',
    //       displayName: 'menu.fileUpload',
    //     },
    //     {
    //       name: 'grid',
    //       displayName: 'menu.grid',
    //     },
    //     {
    //       name: 'icon-sets',
    //       displayName: 'menu.icons',
    //       children: [
    //         {
    //           displayName: 'concrete',
    //           name: 'icon-set',
    //         },
    //       ],
    //     },
    //     {
    //       name: 'lists',
    //       displayName: 'menu.lists',
    //     },
    //     {
    //       name: 'modals',
    //       displayName: 'menu.modals',
    //     },
    //     {
    //       name: 'notifications',
    //       displayName: 'menu.notifications',
    //     },
    //     {
    //       name: 'popovers',
    //       displayName: 'menu.popovers',
    //     },
    //     {
    //       name: 'rating',
    //       displayName: 'menu.rating',
    //     },
    //     {
    //       name: 'sliders',
    //       displayName: 'menu.sliders',
    //     },
    //     {
    //       name: 'spacing',
    //       displayName: 'menu.spacing',
    //     },
    //     {
    //       name: 'spinners',
    //       displayName: 'menu.spinners',
    //     },
    //     {
    //       name: 'tabs',
    //       displayName: 'menu.tabs',
    //     },
    //     {
    //       name: 'timelines',
    //       displayName: 'menu.timelines',
    //     },
    //     {
    //       name: 'tree-view',
    //       displayName: 'menu.treeView',
    //     },
    //     {
    //       name: 'typography',
    //       displayName: 'menu.typography',
    //     },
    //   ],
    // },
    // {
    //   name: 'maps',
    //   displayName: 'menu.maps',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-maps',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'google-maps',
    //       displayName: 'Google Maps',
    //     },
    //     {  admin: true,x-maps',
    //       displayName: 'Yandex Maps',
    //     },
    //     {
    //       name: 'leaflet-maps',
    //       displayName: 'Leaflet Maps',
    //     },
    //     {
    //       name: 'bubble-maps',
    //       displayName: 'Bubble Maps',
    //     },
    //     {
    //       name: 'line-maps',
    //       displayName: 'Line Maps',
    //     },
    //   ],
    // },
    // {
    //   name: 'pages',
    //   displayName: 'menu.pages',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-files',
    //   },  admin: true,
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'Login/Signup',
    //     },
    //     {
    //       name: '404-pages',
    //       displayName: '404 Pages',
    //     },
    //   ],
    // },
  ],
}
